// extracted by mini-css-extract-plugin
module.exports = {"root":"_1zB5ipL"};
    if(module.hot) {
      // 1545369447442
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  